/* Etiquetas multiidoma en castellano. */
export default {
  "paginationControls.summary": "{first} - {last} de {totalCount}",
};
